"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripSubjectPrefix = void 0;
var lodash_1 = __importDefault(require("lodash"));
var three_sixty_1 = require("@shared/types/three-sixty");
/**
 * Remove the 'Subject' prefix from a subject metadata field, if needed.
 * @param fieldId Person metadata field
 */
function stripSubjectPrefix(fieldId) {
    if (lodash_1.default.startsWith(fieldId, three_sixty_1.SUBJECT_FIELD_PREFIX) && fieldId.length > three_sixty_1.SUBJECT_FIELD_PREFIX.length) {
        return fieldId.slice(three_sixty_1.SUBJECT_FIELD_PREFIX.length);
    }
    return fieldId;
}
exports.stripSubjectPrefix = stripSubjectPrefix;
